/* eslint-disable no-magic-numbers */
import { rest } from "msw";
import openidConfigValue from "./openid-configuration";

export const handlers = [
    // rest.get("http://127.0.0.1:8090/auth/realms/master/.well-known/openid-configuration", (req, res, ctx) => {
    //     return res(
    //         ctx.json(openidConfigValue)
    //       )
    // }),
    // rest.get("http://127.0.0.1:8090/*", (req, res, ctx) => {
    //     return res(
    //         ctx.status(200),
    //         ctx.set('Content-Type', 'text/html'),
    //         ctx.body('<html>Hello Mock</html>')
    //       )
    // })
];
